import React from "react";

export default function SectionLabel({ children, light = false, className = "" }) {
  return (
    <div className={`section-label ${light ? "section-label-light" : ""} ${className}`}>{children}</div>
  );
}
